export const SET_HRES83E_INDEX_DISP = 'SET_HRES83E_INDEX_DISP'
export const GET_HRES83E_INDEX_DISP = 'GET_HRES83E_INDEX_DISP'
export const SET_HRES83E_ASSET_DETAIL_DISP = 'SET_HRES83E_ASSET_DETAIL_DISP'
export const GET_HRES83E_ASSET_DETAIL_DISP = 'GET_HRES83E_ASSET_DETAIL_DISP'
export const SET_HRES83E_DETAIL_DISP = 'SET_HRES83E_DETAIL_DISP'
export const GET_HRES83E_DETAIL_DISP = 'GET_HRES83E_DETAIL_DISP'
export const SET_HRES83E_CALENDAR_DETAIL_DISP = 'SET_HRES83E_CALENDAR_DETAIL_DISP'
export const GET_HRES83E_CALENDAR_DETAIL_DISP = 'GET_HRES83E_CALENDAR_DETAIL_DISP'
export const SET_HRES83E_RESERVE_DISP = 'SET_HRES83E_RESERVE_DISP'
export const GET_HRES83E_RESERVE_DISP = 'GET_HRES83E_RESERVE_DISP'
export const SET_HRES83E_COLUMNS = 'SET_HRES83E_COLUMNS'
export const GET_HRES83E_COLUMNS = 'GET_HRES83E_COLUMNS'
export const SET_HRES83E_LABELS = 'SET_HRES83E_LABELS'
export const GET_HRES83E_LABELS = 'GET_HRES83E_LABELS'
export const RECEIVED_HRES83E_COLUMNS_LABELS = 'RECEIVED_HRES83E_COLUMNS_LABELS'
export const SET_HRES83E_INDEX = 'SET_HRES83E_INDEX'
export const GET_HRES83E_INDEX = 'GET_HRES83E_INDEX'
export const RECEIVED_HRES83E_INDEX = 'RECEIVED_HRES83E_INDEX'
export const SET_HRES83E_ASSET_DETAIL = 'SET_HRES83E_ASSET_DETAIL'
export const GET_HRES83E_ASSET_DETAIL = 'GET_HRES83E_ASSET_DETAIL'
export const RECEIVED_HRES83E_ASSET_DETAIL = 'RECEIVED_HRES83E_ASSET_DETAIL'
export const SET_HRES83E_CALENDAR = 'SET_HRES83E_CALENDAR'
export const GET_HRES83E_CALENDAR = 'GET_HRES83E_CALENDAR'
export const RECEIVED_HRES83E_CALENDAR = 'RECEIVED_HRES83E_CALENDAR'
export const SET_HRES83E_CALENDAR_DETAIL = 'SET_HRES83E_CALENDAR_DETAIL'
export const GET_HRES83E_CALENDAR_DETAIL = 'GET_HRES83E_CALENDAR_DETAIL'
export const RECEIVED_HRES83E_CALENDAR_DETAIL = 'RECEIVED_HRES83E_CALENDAR_DETAIL'
export const SET_HRES83E_RESERVE_DETAIL = 'SET_HRES83E_RESERVE_DETAIL'
export const GET_HRES83E_RESERVE_DETAIL = 'GET_HRES83E_RESERVE_DETAIL'
export const RECEIVED_HRES83E_RESERVE_DETAIL = 'RECEIVED_HRES83E_RESERVE_DETAIL'
export const RECEIVED_HRES83E_RESERVE_CREATE = 'RECEIVED_HRES83E_RESERVE_CREATE'
export const SET_HRES83E_INDEX_SELECTED = 'SET_HRES83E_INDEX_SELECTED'
export const GET_HRES83E_INDEX_SELECTED = 'GET_HRES83E_INDEX_SELECTED'
export const SET_HRES83E_CALENDAR_SELECTED = 'SET_HRES83E_CALENDAR_SELECTED'
export const GET_HRES83E_CALENDAR_SELECTED = 'GET_HRES83E_CALENDAR_SELECTED'
export const TOGGLE_HRES83E_PAGE = 'TOGGLE_HRES83E_PAGE'
export const SET_HRES83E_DATE_SELECTED = 'SET_HRES83E_DATE_SELECTED'
export const GET_HRES83E_DATE_SELECTED = 'GET_HRES83E_DATE_SELECTED'
export const POST_HRES83E_RESERVE_CANCEL = 'POST_HRES83E_RESERVE_CANCEL'
export const POST_HRES83E_RESERVE_SAVE = 'POST_HRES83E_RESERVE_SAVE'



// WEBPACK FOOTER //
// ./src/store/modules/hres83e/mutation-types.js